var mixin = require("../../general.js").mixin;
var ObservableTreeNode = require("../../observable/tree/observableTreeNode.js");
var HashMap = require("../../collections/hashMap.js");
var ObservableTreeValue = require("../../observable/tree/observableTreeValue");


var AbstractInstance = function () {
    var self = this;
    this.makeObservableTreeNode();

    this.instanceCollections = new HashMap();

    // TODO: kinda hacky!!
    this.template = ObservableTreeValue.createNewFunction(this, "template", false);
    this.template.nonPersistent = true;    // TODO

    this.description = this.shadow("description",
        function() {
            return this.template() instanceof AbstractInstance ? this.template().description() : this.template();
        }, null,
        [[this.template, this.template.onBubble]]
        // [[this.template, this.template.onBubble,
        //   function(event) {
        //     return event.path.length === 0  //template changes
        //         || event.path.length === 1 && event.path[0].collection.getName() === "description"; //template().description changes
        //     }]]
    );

    // All references of template will be added to this instance in order to mirror the template tree in this instance Tree
    this.onInit("initInstances", this.initInstances, 1);    // TODO: this is not entirely correct! order is not correct
    this.onDie("killInstances", this.killInstances, +Infinity);
};
mixin(AbstractInstance, ObservableTreeNode);

// TODO: following functions are very similar to observableTreeNode, see if we can reuse code
AbstractInstance.prototype.forEachInstanceMember = function(f, childOnly, nonNullOnly){
    this.instanceCollections.forEach(function(name, col){
        if (!childOnly || col.isOwner()){
            if (col.getType() == 'value'){
                if (!nonNullOnly || col() != null) f(col(), col);
            } else {
                col.forEach(function(key, val){
                    if (!nonNullOnly || val != null) f(val, col, key);
                });
            }
        }
    });
};

AbstractInstance.prototype.forEachInstance = function(f){
    this.instanceCollections.forEach(function(name, col){
        if (col.isOwner()){
            if (col.getType() == 'value'){
                if (col() != null) f(col(), col);
            } else {
                col.forEach(function(key, val){
                    if (val != null) f(val, col, key);
                });
            }
        }
    });
};

AbstractInstance.prototype.initInstances = function(){
    var self = this;
    this.forEachInstance(function(instance){
        instance._addToRoot(self.root);
    });
};

AbstractInstance.prototype.killInstances = function(){
    var self = this;
    this.forEachInstance(function(instance){
        instance._removeFromRoot(self.root);
    });
};

AbstractInstance.prototype.getBuilder = function(){// TODO: maybe replace this by shadow
    return this.parent().getBuilder();
};
var skip_members = ["parent", "ancestor", "template", "description"];

AbstractInstance.prototype.sanityCheck = function() {
    ObservableTreeNode.sanityCheck.call(this);

    // if(!this.isAlive()) return; //this shouldn't really happen, but currently it does during undo

    var self = this;
    console.assert(self.template() != null);
    console.assert(self.description() != null);
    if(self.persistent)
        console.assert(self.getParentMember().isPersistent());
    self.collections.forEach(function(name, member) {
        var template_member = self.template().collections.get(name);
        if(!template_member) return; //not an instantiated member
        if(true //template_member.isPersistent()
            && skip_members.indexOf(template_member) !== -1)
            console.assert(self.persistent);
        if(skip_members.indexOf(name) !== -1) return;
        switch(member.getType()){
            case "value":
                if(member() === null)
                    console.assert(template_member() === null);
                else
                    console.assert(!member().isObservableTreeNode || member().template() === template_member());
                break;

            case "set":
                console.assert(member.size() === template_member.size());
                break;

            case "map":
                console.assert(member.size() === template_member.size());
                break;

            case "list":
                console.assert(member.size() === template_member.size());
                break;

            default:
                throw new Error("unknown type");
        }
    });
};

module.exports = AbstractInstance;
